import { Controller } from '@hotwired/stimulus';
import Splide from '@splidejs/splide';

export default class extends Controller {
    splide;

    async connect() {
        this.splide = new Splide(this.element, {
            type: 'loop',
            arrows: false,
            pagination: false,
            perPage: 1,
            autoplay: true,
            drag: false,
            lazyLoad: 'nearby',
            preloadPages: 1,
        }).mount();
    }
}
